// Unpublished Work © 2022-2024 Deere & Company.

import {formatLocalizedTime, formatMinutesToHours} from 'Utils/time-utils';
import moment from 'moment';
const DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};

function getMovingDirection(mowingPattern) {
    const direction = mowingPattern?.direction || '';
    const direction2 = mowingPattern?.direction2 ? `, ${mowingPattern?.direction2}` : '';

    return direction + direction2;
}

function makeReportEntry(workItem, title, workboardTitle, mowingPattern, translations, teamMember) {
    const {
        appUser,
        dateSelect,
        equipment,
        note,
        operatorNote,
        route,
        routeCustomDefn,
        preStartCheck,
        workItemId
    } = workItem;

    let operator = '';

    if (teamMember) {
        operator = `${teamMember.firstName} ${teamMember.lastName}`;
    } else if (appUser) {
        operator = `${appUser.firstName} ${appUser.lastName}`;
    } else {
        operator = translations.ONLINK_USER_NOT_AVAILABLE;
    }

    const formattedDate = formatLocalizedTime(moment(dateSelect).toDate(), DATE_FORMAT);

    const equipmentNames = equipment?.map((piece) => piece.equipmentName).join(', ');
    const formattedPreStartCheck = preStartCheck ? translations.yes : translations.no;
    const estDuration = formatMinutesToHours(workItem.estDuration);
    const actualDuration = formatMinutesToHours(workItem.actualDuration);

    const mowingDirection = getMovingDirection(mowingPattern);

    const routeCol = route === 'Custom' ? routeCustomDefn?.join(',') : route;

    return {
        title,
        operator,
        formattedDate,
        dateSelect: moment.utc(workItem.dateSelect, 'YYYYMMDD', true).local(),
        equipmentNames,
        estDuration,
        actualDuration,
        operatorNote,
        note,
        formattedPreStartCheck,
        mowingDirection,
        route: routeCol,
        workboardTitle,
        id: workItemId
    };
}

function getFormattedJobs(jobList, translations, teamMembers) {
    return jobList.reduce((accumulatedList, job) => {
        const {
            title,
            workItems,
            workboardTitle,
            mowingPattern
        } = job;

        if (workItems?.length) {
            const workItemsMap = workItems.map((workItem) => {
                const teamMember = teamMembers.find((tm) => tm.id === workItem.appUserId);

                if (teamMember) {
                    return makeReportEntry(workItem, title, workboardTitle, mowingPattern, translations, teamMember);
                }
                return makeReportEntry(workItem, title, workboardTitle, mowingPattern, translations);
            });

            return accumulatedList.concat(workItemsMap);
        }

        return accumulatedList;
    }, []);
}

export {
    getFormattedJobs
};
